/* eslint-disable no-console */

import { register } from 'register-service-worker'

import {frontendClient} from "./lib/client"

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function tryObtainNotifications(registration) {
  registration.pushManager.getSubscription().then(async (subscription) => {
    if(subscription) {
      return subscription;
    }

    let apidata = await frontendClient.postAuthenticatedEx("auth/vapid/publickey");
    let publicKey = urlBase64ToUint8Array(apidata.publicKey);

    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: publicKey,
    });

    await frontendClient.postAuthenticatedEx("auth/vapid/register",subscription);

    frontendClient.wsClient.launchRequest("setVapid",subscription);

    console.log("You're now registered with our server for push notifications :)");
  });
}

if (process.env.NODE_ENV === 'production') {
  if(navigator.serviceWorker) {
    navigator.serviceWorker.ready.then(tryObtainNotifications);
  }
  
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
